const populateEventInputs = (): void => {
  const eventName: string | null =
    (<HTMLElement | null>document.querySelector(".js-event-name"))?.innerText
      .replace(/(\r\n|\n|\r)/gm, " ")
      .trim() || null;

  const hiddenEventNameInput: HTMLInputElement | null = <
    HTMLInputElement | null
  >document.querySelector('input[name="eventName"]');

  if (eventName && hiddenEventNameInput) {
    hiddenEventNameInput.value = eventName;
  }

  const eventId: string | undefined = (<HTMLElement | null>(
    document.querySelector(".js-event-name")
  ))?.dataset.eventId;

  const hiddenEventIdInput: HTMLInputElement | null = <HTMLInputElement | null>(
    document.querySelector('input[name="eventID"]')
  );

  if (eventId && hiddenEventIdInput) {
    hiddenEventIdInput.value = eventId;
  }

  const eventDateTime: string | null =
    (<HTMLElement | null>(
      document.querySelector(".js-event-date-time")
    ))?.innerText
      .replace(/(\r\n|\n|\r)/gm, " ")
      .trim() || null;

  const hiddenEventDateInput: HTMLInputElement | null = <
    HTMLInputElement | null
  >document.querySelector('input[name="eventDate"]');

  if (eventDateTime && hiddenEventDateInput) {
    hiddenEventDateInput.value = eventDateTime;
  }
};

populateEventInputs();
